import { render, staticRenderFns } from "./b2bProvider.vue?vue&type=template&id=60733d2b&scoped=true&"
import script from "./b2bProvider.vue?vue&type=script&lang=js&"
export * from "./b2bProvider.vue?vue&type=script&lang=js&"
import style0 from "./b2bProvider.vue?vue&type=style&index=0&id=60733d2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60733d2b",
  null
  
)

export default component.exports